import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Images } from '../../../constants/images';

import styles from './CreateMemoryGameBannerCarousel.module.css';

export const CreateMemoryGameBannerCarousel = () => {
  return (
    <Swiper
      className={styles.swiper}
      //
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
    >
      <SwiperSlide>
        <div className={styles.imageContainer}>
          <img src={Images.QuickMemoryJOY_01} className={styles.slideContent} />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className={styles.imageContainer}>
          <img src={Images.QuickMemoryJOY_02} className={styles.slideContent} />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className={styles.imageContainer}>
          <img src={Images.QuickMemoryJOY_03} className={styles.slideContent} />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className={styles.imageContainer}>
          <img src={Images.QuickMemoryJOY_04} className={styles.slideContent} />
        </div>
      </SwiperSlide>
    </Swiper>
  );
};
